/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CategoryResponse } from '../../models/category-response';
import { CategoryUpdateModel } from '../../models/category-update-model';

export interface PutApiCategoryV1Id$Plain$Params {
  id: number;

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
      body?: CategoryUpdateModel
}

export function putApiCategoryV1Id$Plain(http: HttpClient, rootUrl: string, params: PutApiCategoryV1Id$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CategoryResponse>> {
  const rb = new RequestBuilder(rootUrl, putApiCategoryV1Id$Plain.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CategoryResponse>;
    })
  );
}

putApiCategoryV1Id$Plain.PATH = '/private/v1/categories/{id}';
